// extracted by mini-css-extract-plugin
export default {"container":"WY-z","heading":"XY-z","links":"YY-z","copy":"ZY-z","subCopy":"_Y-z","linksLeft":"aZ-z","linksCenter":"bZ-z","linksRight":"cZ-z","link":"dZ-z","onlyLink":"eZ-z"};